<script>
import Password from "primevue/password";

export default {
    name: "AdaptersPassword",
    extends: Password,
    props: {
        appendTo: {
            type: String,
            required: false,
            default: '#keysoApp'
        }
    }
}
</script>
